import React from 'react';
import * as S from './styled';

export const Button = ({
  children,
  theme = 'default',
  size = 'small',
  border = 'circle',
  ...restProps
}) => {
  return (
    <S.Button {...restProps} size={size} theme={theme} border={border}>
      {children}
    </S.Button>
  );
};

export const ButtonCyan = ({ children, ...restProps }) => {
  return (
    <Button {...restProps} theme="cyan">
      {children}
    </Button>
  );
};

export const ButtonGreen = ({ children, ...restProps }) => {
  return (
    <Button {...restProps} theme="green">
      {children}
    </Button>
  );
};

export const ButtonLightBlue = ({ children, ...restProps }) => {
  return (
    <Button {...restProps} theme="light-blue">
      {children}
    </Button>
  );
};

export const ButtonRed = ({ children, ...restProps }) => {
  return (
    <Button {...restProps} theme="red">
      {children}
    </Button>
  );
};
